import { render, staticRenderFns } from "./purchase-steps.vue?vue&type=template&id=4e255dec&scoped=true&"
import script from "./purchase-steps.vue?vue&type=script&lang=js&"
export * from "./purchase-steps.vue?vue&type=script&lang=js&"
import style0 from "./purchase-steps.vue?vue&type=style&index=0&id=4e255dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e255dec",
  null
  
)

export default component.exports